<!-- CARD -->
<mat-card class="pc-profile-card">
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">
      <div class="pc-row-top mr-2">
        <div class="pc-user-wrapper">
          <span class="pc-user-image border">
            <img class="pc-user-image" [src]="lightUser?.photoURL?.trim() || './assets/images/profile.jpg'">
          </span>
        </div>
      </div>
      <div class="mt-2">
        <h6 class="pc-name">{{lightUser?.name}}</h6>
        <span class="text-success pc-cursor pc-username">@{{lightUser?.handle}}</span>
      </div>
    </div>

    <div *ngIf="currentUser && currentUser?.ID !== lightUser?.ID"
      class="d-flex align-items-center justify-content-center">
      <span *ngIf="(user$ | async ) as user">
        <button *ngIf="!user?.ifollow" type="button" mat-stroked-button color="primary" (click)="followUser()"
          class="btn btn-sm text-success">Follow</button>

        <button *ngIf="user?.ifollow" mat-stroked-button color="primary" (click)="unFollowUser()"
          class="btn btn-sm text-success pc-following"><span>Following</span></button>
      </span>
      <mat-progress-spinner diameter="30" mode="indeterminate" *ngIf="loading$ | async"></mat-progress-spinner>
    </div>
    <span *ngIf="currentUser && currentUser?.ID === lightUser?.ID">
      <button mat-icon-button routerLink="/{{currentUser?.handle}}/edit" color="primary">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button routerLink="/{{currentUser?.handle}}/settings" color="primary">
        <mat-icon>settings</mat-icon>
      </button>
    </span>
  </div>
  <p class="text-secondary">{{lightUser?.bio}}</p>

  <div class="pc-row-bottom pr-5">
    <div class="pc-followers-count pr-cursor" routerLink="/{{lightUser?.handle}}/followers">
      <span class="h6 font-bold" *ngIf="(user$ | async) as user">{{user?.connections?.followers}}</span>
      <span class="h6 font-bold" *ngIf="!(user$ | async) as user">{{lightUser?.followers}}</span>
      <span class="text-secondary ml-1">Followers</span>
    </div>

    <div class="pc-following-count pr-cursor" routerLink="/{{lightUser?.handle}}/following">
      <span class="h6 font-bold" *ngIf="(user$ | async) as user">{{user?.connections?.following}}</span>
      <span class="h6 font-bold" *ngIf="!(user$ | async) ">{{lightUser?.following}}</span>
      <span class="text-secondary ml-1">Following</span>
    </div>

    <!--    <div class="pc-following-count pr-cursor" routerLink="/{{lightUser?.handle}}" *ngIf="(user$ | async) as user">-->
    <!--      <span class="h6 font-bold">{{user?.lightStats?.postsCount}}</span>-->
    <!--      <span class="text-secondary ml-1">Scrolls</span>-->
    <!--    </div>-->
  </div>

  <!--  <small class="text-muted mt-2">! Not followed by anyone you are following</small>-->
</mat-card>
<!-- END CARD -->